import { ComputedLicence, QuotaUsageContainer } from 'dy-frontend-shared/lib/data/valueObjects';

import '../pages/ClientAiImages/store/init';
import '../pages/ClientBilling/store/init';
import '../pages/ClientBrandProfiles/store/init';
import '../pages/ClientConnections/store/init';
import '../pages/ClientCredits/store/init';
import '../pages/ClientLicences/store/init';
import '../pages/ClientNotes/store/init';
import '../pages/ClientNotifications/store/init';
import '../pages/ClientTaskFeedback/store/init';
import '../pages/ClientTasks/store/init';
import '../pages/ClientTeams/store/init';

import { fetchClient, fetchClientPaymentAccount, fetchComputedLicence, fetchQuotaUsage } from './effects';
import { $client, $clientPaymentAccount, $computedLicence, $quotaUsage } from './states';

// Fetch client
$client.on(fetchClient.doneData, (_, data) => data);

// Fetch client payment account
$clientPaymentAccount.on(fetchClientPaymentAccount.doneData, (_, data) => data);

// Fetch computed licence
$computedLicence.on(fetchComputedLicence.doneData, (_, data) => ComputedLicence.createFromRepositoryResource(data));

// Fetch quota usage
$quotaUsage.on(fetchQuotaUsage.doneData, (current, data) => {
    // Build next container
    const next = QuotaUsageContainer.createFromRepositoryResourceList(data.items);

    // Merge if already present
    return current !== null ? current.merge(next) : next;
});
